<template>
    <div class="copy-element">
        <CompassLink
            :label="linkLabel"
            :link="url"
            :type="color"
            :target="blank ? '_blank' : '_self'"
        />
        <clipboard :data="linkLabel" />
    </div>
</template>
<script>
import Clipboard from 'vcomponents/utilities/Clipboard.vue';
export default {
    components: {
        Clipboard,
    },
    props: {
        color: {
            type: String,
            default: 'primary',
        },
        url: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        blank: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        linkLabel() {
            return this.label !== '' ? this.label : this.url;
        },
    },
};
</script>
<style lang="scss">
.copy-element {
    display: inline-block;
}
</style>
